import { detectLanguage } from '@tsl-frontend/tsl-locale';

import { componentRegistry } from './componentRegistry';

export const regionComponents = componentRegistry[detectLanguage()];
